/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Search criteria for partner search within a business relation
 * @export
 * @interface PartnersBrSearchRequest
 */
export interface PartnersBrSearchRequest {
    /**
     * Partner name or partner number to search for
     * @type {string}
     * @memberof PartnersBrSearchRequest
     */
    searchTerm?: string;
    /**
     * Maximum number of results to return. Use -1 to return all matches.
     * @type {number}
     * @memberof PartnersBrSearchRequest
     */
    limitResults?: number;
    /**
     * Depth for P2P searching.
     * @type {number}
     * @memberof PartnersBrSearchRequest
     */
    p2pDepth?: number;
}

/**
 * Check if a given object implements the PartnersBrSearchRequest interface.
 */
export function instanceOfPartnersBrSearchRequest(value: object): value is PartnersBrSearchRequest {
    return true;
}

export function PartnersBrSearchRequestFromJSON(json: any): PartnersBrSearchRequest {
    return PartnersBrSearchRequestFromJSONTyped(json, false);
}

export function PartnersBrSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnersBrSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'searchTerm': json['searchTerm'] == null ? undefined : json['searchTerm'],
        'limitResults': json['limitResults'] == null ? undefined : json['limitResults'],
        'p2pDepth': json['p2pDepth'] == null ? undefined : json['p2pDepth'],
    };
}

export function PartnersBrSearchRequestToJSON(json: any): PartnersBrSearchRequest {
    return PartnersBrSearchRequestToJSONTyped(json, false);
}

export function PartnersBrSearchRequestToJSONTyped(value?: PartnersBrSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchTerm': value['searchTerm'],
        'limitResults': value['limitResults'],
        'p2pDepth': value['p2pDepth'],
    };
}

